import { MatDialogRef } from '@angular/material/dialog';
import { EndUserLicenseAgreementItem } from '../models/end-user-license-agreement.model';
import { ConfirmationDialogComponent } from '../../../../../ui-kit/confirmation-dialog/confirmation-dialog.component';

export class EndUserLicenseAgreementItemLoad {
  public static readonly type = '[EndUserLicenseAgreementItem] Load';

  constructor(public payload: number) {}
}

export class EndUserLicenseAgreementItemSave {
  public static readonly type = '[EndUserLicenseAgreementItem] Save';

  constructor(public payload: Partial<EndUserLicenseAgreementItem>) {}
}

export class EndUserLicenseAgreementItemPublish {
  public static readonly type = '[EndUserLicenseAgreementItem] Publish';

  constructor(public payload: { eulaItemId: number; dialog: MatDialogRef<ConfirmationDialogComponent> }) {}
}

export class EndUserLicenseAgreementItemInitialState {
  public static readonly type = '[EndUserLicenseAgreementItem] Set initial state';
}
